import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import LanguageSwitcher from './LanguageSwitcher';
import {SYSTEM_UNION_CODE} from "../../config";

const Footer = () => {

  const { t } = useTranslation();

  const includeEnvironmentDetail = true;

  return (
    <footer className="navbar-light bg-light fixed-bottom">
      <div className="container-fluid">
        <div className="row justify-content-between">
          <div className="col">{t("footer:version")}: {process.env.REACT_APP_VERSION} {includeEnvironmentDetail ? process.env.REACT_APP_ENVIRONMENT : null} {SYSTEM_UNION_CODE}</div>
          <div className="col text-center"><a href="http://www.unece.org/legal_notice/copyrightnotice.html" target="_blank" rel="noreferrer">{t('footer:copyright')}</a></div>
          <div className="col text-end"><LanguageSwitcher /></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;